import { Link, useLocation } from 'react-router-dom';

interface SidebarProps {
  onLogout: () => void;
}

export default function Sidebar({ onLogout }: SidebarProps) {
  const location = useLocation();

  const menuItems = [
    { icon: 'ri-dashboard-line', label: 'Dashboard', path: '/admin' },
    { icon: 'ri-settings-3-line', label: 'Site Ayarları', path: '/admin/settings' },
    { icon: 'ri-menu-line', label: 'Menü Yönetimi', path: '/admin/menus' },
    { icon: 'ri-pages-line', label: 'Sayfa Yönetimi', path: '/admin/pages' },
    { icon: 'ri-article-line', label: 'Blog Yazıları', path: '/admin/blog' },
    { icon: 'ri-image-line', label: 'Medya Kütüphanesi', path: '/admin/media' },
    { icon: 'ri-slideshow-line', label: 'Slider Yönetimi', path: '/admin/sliders' },
    { icon: 'ri-tools-line', label: 'Hizmetler', path: '/admin/services' },
    { icon: 'ri-building-line', label: 'Markalar', path: '/admin/brands' },
    { icon: 'ri-mail-line', label: 'Mesajlar', path: '/admin/messages' },
    { icon: 'ri-user-line', label: 'Kullanıcılar', path: '/admin/users' },
  ];

  return (
    <aside className="w-64 bg-gray-900 text-white min-h-screen flex flex-col">
      <div className="p-6 border-b border-gray-800">
        <h1 className="text-xl font-bold">3D PR Admin</h1>
        <p className="text-sm text-gray-400 mt-1">Yönetim Paneli</p>
      </div>

      <nav className="flex-1 p-4">
        {menuItems.map((item) => (
          <Link
            key={item.path}
            to={item.path}
            className={`flex items-center gap-3 px-4 py-3 rounded-lg mb-2 transition-colors cursor-pointer ${
              location.pathname === item.path
                ? 'bg-teal-600 text-white'
                : 'text-gray-300 hover:bg-gray-800'
            }`}
          >
            <i className={`${item.icon} text-lg w-5 h-5 flex items-center justify-center`}></i>
            <span className="text-sm whitespace-nowrap">{item.label}</span>
          </Link>
        ))}
      </nav>

      <div className="p-4 border-t border-gray-800">
        <button
          onClick={onLogout}
          className="flex items-center gap-3 px-4 py-3 rounded-lg w-full text-gray-300 hover:bg-gray-800 transition-colors cursor-pointer whitespace-nowrap"
        >
          <i className="ri-logout-box-line text-lg w-5 h-5 flex items-center justify-center"></i>
          <span className="text-sm">Çıkış Yap</span>
        </button>
      </div>
    </aside>
  );
}
